module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAJ1BMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMNgns7z+PuFtdr///+20ul1/l9mAAAACHRSTlMAYL//ACDP71kzCuAAAADhSURBVHja7di5EcQwEANB/nrI/OM9yRpPMLBV53ACaB9Ib7lUo5LbU2qtj2o2+gv1o9od/YFGDWi0lGtIOZUYqKQa1IY2RKLzui0IZ87bgnCQBCQcJAEJB0lAwkESkHKQFKQdJA0t4SAJaC7hIAkICYeQNDSXdualIaQv59QQknAUhCQcBSEJR0FI2tHQKwlHQiQcA8IxIBwLwvEgHA/C8SAcD8LxIBwPwvEhHB/CMaHlQkguhORCSC6E5EJILoTkQkguhORCSHtCbGhD/4TCTpaw2yfqiAq7xiLPuqeI+/AH7vZbLrsAZVUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/2199.png
// module id = 1321
// module chunks = 0